import { render } from "./LayoutView.vue?vue&type=template&id=6d4f5f24&scoped=true"
import script from "./LayoutView.vue?vue&type=script&lang=js"
export * from "./LayoutView.vue?vue&type=script&lang=js"

import "./LayoutView.vue?vue&type=style&index=0&id=6d4f5f24&lang=css&scoped=true"

import exportComponent from "E:\\Projects\\webDesign\\trello-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4f5f24"]])

export default __exports__